import moment from "moment";

const MESES = {
  ene: 0, enero: 0,
  feb: 1, febrero: 1,
  mar: 2, marzo: 2,
  abr: 3, abril: 3,
  may: 4, mayo: 4,
  jun: 5, junio: 5,
  jul: 6, julio: 6,
  ago: 7, agosto: 7,
  sep: 8, septiembre: 8, sept: 8,
  oct: 9, octubre: 9,
  nov: 10, noviembre: 10,
  dic: 11, diciembre: 11,
};

function parsearFecha(dateStr) {
  const match = dateStr.match(/^(?:(\d{1,2})\/)?([a-z]+)\/(\d{4})$/i);
  if (!match) return null;
  const mes = MESES[match[2].toLowerCase()];
  if (mes === undefined) return null;
  return moment({ year: parseInt(match[3], 10), month: mes, day: match[1] ? parseInt(match[1], 10) : 1 });
}

/**
 * Parsea las líneas de texto extraídas de un PDF de Medicinas Rosario.
 * Retorna un Map<descripcionLower, { lotes, cantidadLinea }>
 *
 * Formatos de fecha soportados: 31/ene/2028 y junio/2027
 * Maneja descripciones que envuelven a múltiples líneas: la línea del LAB
 * (ej. "ADM N $90.00...") marca el fin del producto.
 */
export function parsearLineasRosario(allLines) {
  // Línea que empieza con clave numérica + cantidad + H87 + Pieza + lote + fecha
  const PRODUCT_START = /^(\d{5,10})\s+(\d+)\s+H87\s+Pieza\s+(\S+)\s+((?:\d{1,2}\/)?[a-z]+\/\d{4})\s*(.*)/i;
  // Línea de precios que sigue a una descripción envuelta: "ADM N $..."
  const LAB_LINE = /^[A-Z]{2,4}\s+[TN]\s+\$/;
  // Cola al final de una descripción en línea completa: " LGE T $..."
  const DESC_TAIL = /\s+[A-Z]{2,4}\s+[TN]\s+\$.*/;

  const productos = [];
  let current = null;

  for (const line of allLines) {
    const prodMatch = line.match(PRODUCT_START);
    if (prodMatch) {
      if (current) productos.push(current);
      const rest = prodMatch[5];
      current = {
        piezas: parseInt(prodMatch[2], 10),
        lote: prodMatch[3],
        caducidad: parsearFecha(prodMatch[4]),
        descripcion: rest.replace(DESC_TAIL, '').trim(),
      };
      if (DESC_TAIL.test(rest)) {
        productos.push(current);
        current = null;
      }
      continue;
    }

    if (current) {
      if (LAB_LINE.test(line)) {
        productos.push(current);
        current = null;
      } else {
        current.descripcion = (current.descripcion + ' ' + line.trim()).trim();
      }
    }
  }
  if (current) productos.push(current);

  const productsByDesc = new Map();
  for (const prod of productos) {
    if (!prod.descripcion) continue;
    const key = prod.descripcion.toLowerCase().trim();
    if (!productsByDesc.has(key)) productsByDesc.set(key, { lotes: [], cantidadLinea: null });
    const entry = productsByDesc.get(key);
    if (prod.caducidad) {
      const dup = entry.lotes.find(l => l.numero === prod.lote);
      if (dup) {
        dup.cantidad = (Number(dup.cantidad) || 0) + prod.piezas;
      } else {
        entry.lotes.push({ numero: prod.lote, caducidad: prod.caducidad, cantidad: prod.piezas });
      }
    } else {
      entry.cantidadLinea = (entry.cantidadLinea || 0) + prod.piezas;
    }
  }

  return productsByDesc;
}
